import { Spin, notification } from "antd";
import { InboundEmail } from "../api/models";
import EmailTag from "./EmailTag";
import { useState } from "react";
import APIClient from "../api/api";

export interface Props {
    email: InboundEmail
    removable: boolean;
    onTagsUpdated: () => void;
}

const EmailTagList = (props: Props) => {
    const [loading, setLoading] = useState(false);

    async function onRemove(tag: string) {
        try {
            setLoading(true);
            await APIClient.deleteEmailTag(props.email.id, tag);
            props.onTagsUpdated();
        }
        catch(e) {
            notification.error({message: 'Failed to update tags.'});
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <Spin spinning={loading}>
            <div style={{ display: 'flex', gap: '5px' }}>
                {props.email.tags.map(tag => (
                    <EmailTag key={tag} tag={tag} canRemove={props.removable} onRemove={onRemove} />
                ))}
            </div>
        </Spin>
    );
};
export default EmailTagList;
